import http from '@/components/services/http-common';

export const get = () => {
  return http.get('FacialCheckinDisables').then(r => r.data)
}

export const post = (formData) => {
  return http.post('FacialCheckinDisables', formData)
}

export const remove = (id) => {
  return http.delete('FacialCheckinDisables/'+id)
}